var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomEventCommand } from '../../../commands/hub/custom.event.command';
import { VisitorCalendarActionCommand, VisitorStyleCommand, } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { HubVisitorPromotionImage } from '../../../models/hub/hub.visitor.promotion.image';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore, VisitorStyleStore, } from '../../../stores/visitor.calendar.store';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { config } from '../../../../config/config';
import { ModalService } from '../../../common/services/modal.service';
import { DomSanitizer } from '@angular/platform-browser';
import { VisitorComponent } from '../visitor.component';
import { CustomDefaultPlaceCategoryItemSelectionStore, EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../../hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { EventFilterComponent } from '../event.filter/event.filter.component';
import { CustomPlaceBtnComponent } from '../custom.place.btn/custom.place.btn.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
var VisitorSideBarComponent = /** @class */ (function (_super) {
    __extends(VisitorSideBarComponent, _super);
    function VisitorSideBarComponent(router, activatedRoute, visitorCalendarStore, customDefaultPlaceCategoryItemSelectionStore, formBuilder, visitorApiService, parent, editorChoiceStore, visitorStyleStore, allFrontendSettingsStore, domSanitizer, imageService, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.customDefaultPlaceCategoryItemSelectionStore = customDefaultPlaceCategoryItemSelectionStore;
        _this.formBuilder = formBuilder;
        _this.visitorApiService = visitorApiService;
        _this.parent = parent;
        _this.editorChoiceStore = editorChoiceStore;
        _this.visitorStyleStore = visitorStyleStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.domSanitizer = domSanitizer;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.simpleMenu = true;
        _this.today = new Date();
        _this.command = new VisitorCalendarActionCommand();
        _this.selectedCustomEvent = new CustomEventCommand();
        _this.selectedCustomPlace = null;
        _this.visitorPromotionImage = new HubVisitorPromotionImage();
        _this.eventPositionImage = config.eventPositionImage;
        _this.customDefaultPlaceCategory = null;
        _this.searchParam = {
            searchTimeout: null,
            debounceTime: 500,
            isSearching: false,
        };
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.toggleAndSource = new HubVisitorToggleDataSource();
        _this.loadingToggles = true;
        _this.onClose = new EventEmitter();
        _this.editorChoiceText = '';
        _this.selectedEvents = null;
        _this.isEditorChoice = null;
        return _this;
    }
    VisitorSideBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, category = _a.category, menuType = _a.menuType;
        this.hubName = hubName;
        this.eventPositionImage = this.imageService.imageSourceUrl(this.eventPositionImage);
        this.setMenuType(menuType, category);
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.visitorCalendarStore.actionCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            _this.command = command;
            console.log('command in sidebar', _this.command);
            _this.setSelectedDefaultCategoryFilterBackFromMapView();
            _this.setQueryCommand(menuType, category);
            // get the selected category back from map view
            if (_this.command.queryCommand.category && _this.menuType !== 'custom') {
                _this.category = _this.command.queryCommand.category;
                console.log('this.category in sidebar command', _this.category);
            }
            // custom place btn selected, back from map view
            if (_this.command.queryCommand.customPlaceBtnText) {
                _this.customPlaceBtn &&
                    _this.customPlaceBtn.setFilter(_this.command.queryCommand.customPlaceBtnText, _this.command.queryCommand.choice);
            }
        });
        this.searchFormGroup = this.formBuilder.group({
            searchText: [null],
        });
        this.dateFormGroup = this.formBuilder.group({
            from: [null, [Validators.required]],
            to: [null, [Validators.required]],
        });
        this.loadSettings();
        this.editorChoiceTextHandler();
    };
    VisitorSideBarComponent.prototype.loadSettings = function () {
        var _this = this;
        this.loadingToggles = true;
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.customSettings) {
                _this.customEvents = command.customSettings.customEvents || null;
                _this.customPlaces = command.customSettings.customPlaces || null;
                _this.isHideEditorChoice = command.customSettings.isHideEditorChoice || false;
                _this.visitorPromotionImage = command.customSettings.visitorPromotion || null;
                if (command.customSettings.logo && !command.customSettings.logo.isDefault) {
                    _this.eventPositionImage = _this.imageService.imageSourceUrl(command.customSettings.logo.url);
                }
                _this.setCustomDefaultPlaceCategory(command.customSettings.customDefaultPlaceCategory);
            }
            if (command.toggle) {
                _this.featuresToggle = command.toggle;
                if (_this.isAllPlaceCategoriesTurnedOff) {
                    _this.featuresToggle.placeCalendar = false;
                }
                _this.loadingToggles = false;
                _this.toggleAndSource.toggle = _this.featuresToggle;
                _this.toggleAndSource.dataSource = command.dataSource;
                if (!_this.command.isEventCalendar) {
                    _this.command.queryCommand.category = _this.category;
                    _this.command.queryCommand.source = _this.toggleAndSource.dataSource.place;
                }
            }
        });
    };
    VisitorSideBarComponent.prototype.setQueryCommand = function (menuType, category) {
        var _this = this;
        !!this.activatedRoute.firstChild &&
            this.activatedRoute.firstChild.url.subscribe(function (x) {
                // this.command.isEventCalendar = (x[0].path === routeConfigs.visitor.eventCalendar.path || routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0);
                if (x[0].path === routeConfigs.visitor.eventCalendar.path ||
                    x[0].path === routeConfigs.visitor.editorChoice.path ||
                    routeConfigs.visitor.customEvent.path.indexOf(x[0].path) >= 0 ||
                    routeConfigs.visitor.eventDetailsModal.path.indexOf(x[0].path) >= 0) {
                    _this.command.isEventCalendar = true;
                }
                else {
                    _this.command.isEventCalendar = false;
                }
                if (x[0].path === routeConfigs.visitor.editorChoice.path ||
                    x[0].path === routeConfigs.visitor.placeEditorChoice.path) {
                    _this.command.queryCommand.choice = true;
                }
                // else {
                //     this.command.queryCommand.choice = false;
                // }
            });
    };
    VisitorSideBarComponent.prototype.setMenuType = function (menuType, category) {
        this.menuType = menuType || null;
        if (this.menuType === 'custom') {
            this.categoryId = category;
        }
        else {
            this.category = category || 'All';
        }
        this.simpleMenu = menuType === 'simple' && !this.command.isEventCalendar;
        this.command.queryCommand.category = category;
    };
    VisitorSideBarComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe(function (editorChoice) {
            if (!!_this.command.isEventCalendar) {
                _this.editorChoiceText = editorChoice.editorChoiceForEvent;
            }
            else {
                _this.editorChoiceText = editorChoice.editorChoiceForPlace;
            }
        });
    };
    VisitorSideBarComponent.prototype.setSelectedDefaultCategoryFilterBackFromMapView = function () {
        var _this = this;
        // get the selected category back from map view
        if (this.command.queryCommand.category) {
            if (this.menuType !== 'custom') {
                this.category = this.command.queryCommand.category;
                this.setCustomDefaultPlaceFilter(this.category);
            }
            else {
                setTimeout(function () {
                    try {
                        var str = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
                        var data = str ? JSON.parse(str) : { title: _this.command.queryCommand.category };
                        if (data) {
                            _this.setCustomDefaultPlaceFilter(data.title);
                        }
                    }
                    catch (error) {
                        console.log('Not parse selectedPlaceCategory', error.message);
                    }
                }, 1600);
            }
        }
    };
    VisitorSideBarComponent.prototype.setCustomDefaultPlaceFilter = function (title) {
        title = title || '';
        title = title.toLowerCase() === 'all' ? '' : title;
        this.placeCategoryAccordion && this.placeCategoryAccordion.setFilter(title);
    };
    /**
     * if visit a custom default place category url, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
     * */
    VisitorSideBarComponent.prototype.setCustomDefaultPlaceCategory = function (customDefaultPlaceCategory) {
        // if (localStorage.getItem(localStorageKeys.selectedPlaceCategory)) return;
        if (this.menuType === 'custom') {
            // this.category is the custom default place category id, e.g., 62a46ea3e6ad6016f05245ff
            var data = PlaceService.getCustomDefaultCategoryFromURL(this.categoryId, customDefaultPlaceCategory);
            if (data) {
                // this.categoryId = this.category;
                this.category = data.category.title;
                // this.customDefaultPlaceCategory = data.customDefaultPlaceCategory;
                this.customDefaultPlaceCategory = customDefaultPlaceCategory;
                this.command.queryCommand.categoryList = data.categoryList;
                var categoryString = JSON.stringify(data.category);
                this.initialCustomDefaultPlaceCategory = {
                    category: data.category,
                    categoryString: categoryString,
                    categoryList: data.categoryList,
                };
                // for map view
                var storage = localStorage.getItem(localStorageKeys.selectedPlaceCategory);
                if (!storage) {
                    localStorage.setItem(localStorageKeys.selectedPlaceCategory, categoryString);
                }
            }
        }
        else {
            this.customDefaultPlaceCategory = customDefaultPlaceCategory;
        }
        // this.visitorCalendarStore.actionCommand.next(this.command);
    };
    Object.defineProperty(VisitorSideBarComponent.prototype, "isShowThingsToDo", {
        get: function () {
            return (!this.loadingToggles &&
                (this.featuresToggle.placeCategory.activity ||
                    this.featuresToggle.placeCategory.art ||
                    this.featuresToggle.placeCategory.outdoor ||
                    this.featuresToggle.placeCategory.entertainment));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorSideBarComponent.prototype, "isAllPlaceCategoriesTurnedOff", {
        get: function () {
            return PlaceService.isAllCategoriesTurnedOff(this.featuresToggle.placeCategory);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorSideBarComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    VisitorSideBarComponent.prototype.viewChange = function () {
        this.command.isMapView = !this.command.isMapView;
        // this.command.isMapView = true;
        var path = { path: '' };
        if (this.command.isMapView) {
            if (this.command.isEventCalendar) {
                path = routeConfigs.visitor.eventMap;
            }
            else {
                path = routeConfigs.visitor.placeMap;
            }
        }
        else {
            if (this.command.isEventCalendar) {
                path = routeConfigs.visitor.eventCalendar;
            }
            else {
                path = routeConfigs.visitor.placeCalendar;
            }
        }
        if (this.command.isEventCalendar) {
            this.router.navigateByUrl(getRouteUrl(path, {
                hubName: this.hubName,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        else {
            var cate = this.customDefaultPlaceCategory.useDefault
                ? PlaceCategory.getPlaceCategoryKey(this.category)
                : this.menuType === 'custom'
                    ? this.categoryId
                    : 'All';
            this.router.navigateByUrl(getRouteUrl(path, {
                hubName: this.hubName,
                category: cate,
                menuType: this.menuType || (this.simpleMenu ? 'simple' : 'normal'),
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.close();
    };
    VisitorSideBarComponent.prototype.close = function () {
        this.onClose.emit();
    };
    VisitorSideBarComponent.prototype.gotoPlaceCalendar = function () {
        this.searchText = null;
        this.category = 'all';
        var path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;
        this.command.isEventCalendar = false;
        this.command.queryCommand.category = 'All';
        this.command.queryCommand.from = null;
        this.command.queryCommand.search = null;
        this.command.queryCommand.to = null;
        this.command.queryCommand.choice = null;
        this.command.queryCommand.isCustom = null;
        this.command.queryCommand.selectedEvents = null;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.mostAttended = null;
        var styleCommand = new VisitorStyleCommand();
        styleCommand.menuStyle.isSideBar = this.parent.allFrontendSettings.customSettings.menuStyle.isSideBar;
        // styleCommand.menuStyle.menuBarMode = this.parent.menuBarMode;
        this.visitorStyleStore.styleCommand.next(styleCommand);
        this.router.navigateByUrl(getRouteUrl(path, {
            hubName: this.hubName,
            category: this.category,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.close();
    };
    VisitorSideBarComponent.prototype.gotoTripPlanner = function () {
        var path = routeConfigs.tripPlanner.trip; //routeConfigs.visitor.trip;
        this.router.navigateByUrl(getRouteUrl(path, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.close();
    };
    VisitorSideBarComponent.prototype.clearSearchText = function () {
        this.searchText = null;
        this.search(null);
    };
    VisitorSideBarComponent.prototype.search = function ($event) {
        var _this = this;
        if ($event && $event.key === 'Tab') {
            return;
        }
        var isKeepFilter = false;
        if (!isKeepFilter) {
            this.eventDateAccordion && this.eventDateAccordion.clearFilter(null, false);
            this.customEventAccordion && this.customEventAccordion.clearFilter(null, false);
            this.selectedEvents = null;
            this.isEditorChoice = null;
            this.from = null;
            this.to = null;
            this.category = null;
            this.eventFilter && this.eventFilter.clearFilter();
        }
        var command = this.command;
        command.queryCommand.search = this.searchText || null;
        command.queryCommand.from = this.from || null;
        command.queryCommand.to = this.to || null;
        command.queryCommand.category = this.category || null;
        command.queryCommand.choice = this.isEditorChoice;
        command.queryCommand.selectedEvents = this.selectedEvents;
        command.queryCommand.categoryList = null;
        command.queryCommand.customEventBtnText = null;
        command.queryCommand.dateFilterText = null;
        command.queryCommand.isCustom = null;
        command.queryCommand.feedId = null;
        if (!this.command.isEventCalendar) {
            command.queryCommand.from = null;
            command.queryCommand.to = null;
        }
        command.isEventCalendar = this.command.isEventCalendar;
        //this.visitorCalendarStore.actionCommand.next(command);
        this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next(null);
        if (this.searchParam.searchTimeout) {
            clearTimeout(this.searchParam.searchTimeout);
            this.searchParam.searchTimeout = setTimeout(function () {
                _this.searchParam.isSearching = true;
                setTimeout(function () {
                    _this.searchParam.isSearching = false;
                    _this.close();
                }, 4000);
                _this.visitorCalendarStore.actionCommand.next(command);
            }, this.searchParam.debounceTime);
            return;
        }
        this.searchParam.searchTimeout = setTimeout(function () {
            _this.searchParam.isSearching = true;
            setTimeout(function () {
                _this.searchParam.isSearching = false;
                _this.close();
            }, 4000);
            _this.visitorCalendarStore.actionCommand.next(command);
        }, this.searchParam.debounceTime);
    };
    VisitorSideBarComponent.prototype.addEventsManually = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.createEvent, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.close();
    };
    VisitorSideBarComponent.prototype.addPlacesManually = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.createPlace, {
            hubName: this.hubName,
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.close();
    };
    VisitorSideBarComponent.prototype.isSelected = function (title) {
        return !this.command.queryCommand.choice && !this.selectedCustomPlace && this.category === title;
    };
    VisitorSideBarComponent.prototype.filterPlace = function (category) {
        this.searchText = null;
        this.category = category;
        var command = new VisitorCalendarActionCommand();
        command.isEventCalendar = false;
        command.queryCommand.choice = null;
        command.queryCommand.search = null;
        this.selectedCustomPlace = null;
        var path = this.command.isMapView ? routeConfigs.visitor.placeMap : routeConfigs.visitor.placeCalendar;
        if (category === 'selected') {
            command.queryCommand.isCustom = true;
            command.queryCommand.category = null;
            this.router.navigateByUrl(getRouteUrl(path, {
                hubName: this.hubName,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        else {
            // custom default category from URL, e.g., http://localhost:4200/test4/places/62a46ea3e6ad6016f05245ff/custom
            if (this.menuType === 'custom') {
                // all selected, load all categroyList
                command.queryCommand.categoryList = this.initialCustomDefaultPlaceCategory.categoryList;
                // for map view
                localStorage.setItem(localStorageKeys.selectedPlaceCategory, this.initialCustomDefaultPlaceCategory.categoryString);
            }
            else {
                this.category = category;
                command.queryCommand.category = category || null;
                this.placeCategoryAccordion && this.placeCategoryAccordion.clearFilter();
                this.customPlaceBtn && this.customPlaceBtn.clearFilter();
            }
            this.router.navigateByUrl(getRouteUrl(path, {
                hubName: this.hubName,
                category: this.menuType === 'custom' ? this.categoryId : PlaceCategory.getPlaceCategoryKey(this.category),
                menuType: this.menuType,
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        }
        command.queryCommand.source = this.toggleAndSource.dataSource.place;
        this.close();
        this.visitorCalendarStore.actionCommand.next(command);
        this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next(null);
    };
    VisitorSideBarComponent.prototype.closeSidebar = function () {
        this.onClose.emit();
    };
    VisitorSideBarComponent.prototype.selectCustomDefaultPlaceCategory = function ($event) {
        this.category = $event.title;
        // in order for calendar to load when currently showing submit place view
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
            hubName: this.hubName,
            // category: $event.title,
            category: this.menuType === 'custom' ? this.categoryId : 'All',
            menuType: this.menuType,
        }));
        this.command.isEventCalendar = false;
        this.command.queryCommand.feedId = null;
        this.command.queryCommand.category = $event.title;
        this.command.queryCommand.categoryList = $event.categoryList;
        this.command.queryCommand.selectedPlaces = null;
        this.command.queryCommand.isCustom = null;
        this.command.queryCommand.search = '';
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.searchText = '';
        this.command.queryCommand.source = this.toggleAndSource.dataSource.place;
        this.selectedCustomPlace = null;
        this.close();
        $event && this.placeCategoryAccordion && this.placeCategoryAccordion.setFilter($event.title);
        !$event && this.placeCategoryAccordion && this.placeCategoryAccordion.clearFilter();
        this.customPlaceBtn && this.customPlaceBtn.clearFilter();
    };
    return VisitorSideBarComponent;
}(BaseComponent));
export { VisitorSideBarComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/side.bar/visitor.side.bar.component.ts.pre-build-optimizer.js